import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './style.css';

class LibraryActivateModalSalesType extends React.Component {
  render() {
    const {
      onHide,
      showActivatedModal,
      disableHideOnOuterModal,
      title,
      name,
      onActivated,
      isActivate,
    } = this.props;
    const isActivateSelected = isActivate && isActivate.active_state === true;
    const isActivateClassName = isActivateSelected
      ? `${styles.headerDeactivate}`
      : `${styles.headerActivate}`;
    const isActivateBtnSave = isActivateSelected
      ? 'btn btn-danger'
      : 'btn btn-primary';
    return (
      <Modal
        onHide={
          disableHideOnOuterModal
            ? function() {
                /* no op */
              }
            : onHide
        }
        show={showActivatedModal}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header className={isActivateClassName}>
          <button
            onClick={onHide}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <Modal.Title className={styles['title-modal']}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure want to{' '}
            {isActivateSelected ? 'Deactivate' : 'Reactivate'}{' '}
            <b>{name && name.name}</b> {'?'}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button type="button" className="btn btn-default" onClick={onHide}>
              Cancel
            </button>
            <button
              type="button"
              className={isActivateBtnSave}
              onClick={() => {
                onActivated(name);
              }}
            >
              {isActivateSelected ? 'Deactivate' : 'Reactivate'}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

LibraryActivateModalSalesType.propTypes = {
  onHide: PropTypes.func,
  disableHideOnOuterModal: PropTypes.bool,
  showActivatedModal: PropTypes.bool,
  title: PropTypes.string,
  onActivated: PropTypes.func,
};

export default LibraryActivateModalSalesType;
